var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"referrerInfo"},[_c('QS-h4-title',{attrs:{"title":"推荐方"}}),_vm._v(" "),_c('QS-column-box',{attrs:{"source":_vm.source,"list":_vm.list,"column":3,"labelWidth":"150","separator":":"}},[_c('template',{slot:"recommenderRewardAmount"},[_vm._v("\n      "+_vm._s(_vm.recommendAmount)+"\n    ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }